import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import Chart from 'react-apexcharts';
import { H4 } from '@blueprintjs/core';
import { rounded }  from '../../../utils.js'; 
class VocSpecPopup extends React.PureComponent {

  state = {
     
  }


  render() {
        const { t,data,entry } = this.props;

        if (data) {
            let xyTab=[];
            const keys=Object.keys(data).sort();
            for (var i=0;i<keys.length;i++) {
                var key=keys[i];
                //xTab.push(key);
                xyTab.push({x:key,y:data[key]});
            }
           // prep data for the chart
            const series = [{
                name:t('specificity'),
                data:xyTab
            }];
            const options = {
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: {
                        show: true,
                        // offsetX: 0,
                        // offsetY: 0,
                        tools: {
                          download: true,
                        },
                        export: {
                          csv: {
                            filename: "specificity_by_corpus",
                            columnDelimiter: ',',
                            headerCategory: 'Corpus',
                            headerValue: 'Value',
                          },
                          svg: {
                            filename: "specificity_by_corpus",
                          },
                          png: {
                            filename: "specificity_by_corpus",
                          }
                        },
                    }
    
                },
                plotOptions: {
                    bar: {
                        columnWidth: '80%',
                    }
                },
                dataLabels: {
                    enabled: false,
                },
                yaxis: {
                    title: {
                        text: t('specificity'),
                    },
                    labels: {
                        formatter: function (y) {
                            return rounded(y,2);
                        }
                    }
                },
                xaxis: {
                    type: 'text',
                    //categories: xTab,
                    labels: {
                        rotate: -90
                    }
                },
            };

            return (
                <>
                   
                    <Chart options={options} series={series} type="bar" height={350} />
                    <br/>
                    <center><H4>{entry}</H4></center>
                </>
               
            );
        } else {
            return (<></>)
        }
    }
}

VocSpecPopup.propTypes = {
    data: PropTypes.object,
    entry : PropTypes.string,
};

export default withTranslation()(VocSpecPopup);
